<script setup lang="ts">
import Button from 'primevue/button';

import { useDownloadFinancingOffer } from '../composables/useDownloadOffer';
import { useCalculationFinancingPdfData } from '../composables/useCalculationFinancingPdfData';
import { useCurrentCalculation } from '../composables/useCurrentCalculation';
import { useClientsStore } from '../store/clients';
import { buildCalculationFileName } from '../utils/calculationFileName';

const { downloadFinancingOffer, isPending } = useDownloadFinancingOffer();
const { fillFinancingPdfJson } = useCalculationFinancingPdfData();
const { currentCalculation } = useCurrentCalculation();
const clientsStore = useClientsStore();

function onDownload() {
  const calculation = currentCalculation.value;
  const client = calculation?.client_uuid
    ? clientsStore.getClientByUuid(calculation.client_uuid)
    : null;

  const fileName = buildCalculationFileName({
    prefix: 'oferta-finansowanie',
    calculation,
    client,
  });

  const context = fillFinancingPdfJson();
  return downloadFinancingOffer(context as any, fileName);
}
</script>

<template>
  <Button
    class="font-semibold"
    severity="secondary"
    outlined
    size="small"
    :disabled="isPending"
    @click="onDownload"
  >
    <i class="pi pi-file-arrow-up"></i>
    Pobierz ofertę finansowania
  </Button>
</template>
